const CONTAINER_MAX_WIDTH_MAP = {
  sm: 'var(--grid-container-max-width-sm)',
  md: 'var(--grid-container-max-width-md)',
  lg: 'var(--grid-container-max-width-lg)',
  xl: 'var(--grid-container-max-width-xl)',
  xxl: 'var(--grid-container-max-width-xxl)'
}

export default CONTAINER_MAX_WIDTH_MAP
